import { render, staticRenderFns } from "./SplitValueInput.vue?vue&type=template&id=0375f95c&scoped=true"
import script from "./SplitValueInput.vue?vue&type=script&lang=ts"
export * from "./SplitValueInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0375f95c",
  null
  
)

export default component.exports